export const ROUTES = {
  LANDING: "/",
  CUSTOMER_LANDING: "/customer-landing",
  NON_CUSTOMER_LANDING: "/non-customer-landing",
  CUSTOMER_CONTACT: "/customer-contact",
  CUSTOMER_CONTACT_ADDRESS: "/customer-contact-address",
  NON_CUSTOMER_CONTACT: "/non-customer-contact",
};
